<template>
    <div class="thumb-swiper">
        <!-- SWIPER 1 -->
        <swiper
            class="swiper gallery-top mb-2 md:mb-4"
            :options="swiperOptionTop"
            ref="swiperTop"
            @slideChange="onSlide"
        >
            <swiper-slide>
                <div
                    class="wrapper__cover wrapper__cover__video w-full rounded-4 bg-lightgrey-1 flex align-items-center bg-black cursor-pointer"
                    v-if="isVideo(cover)"
                    @click="$emit('showmodalgallery')"
                >
                    <!-- RENDER DEFAULT VIDEO -->
                    <video
                        class="video rounded-4 w-full h-full"
                        :src="cover"
                        controls
                    />
                    <div class="backdrop-zoom">
                        <img
                            class="icon-zoom"
                            src="/assets/images/helpers/icon-zoom.svg"
                            alt=""
                        />
                    </div>
                </div>
                <div
                    class="wrapper__cover wrapper__cover__img w-full rounded-4 bg-lightgrey-1 bg-center bg-cover bg-no-repeat cursor-pointer"
                    @click="$emit('showmodalgallery')"
                    v-else
                >
                    <img :src="cover" />
                    <!-- RENDER COVER -->
                    <div class="backdrop-zoom">
                        <img
                            class="icon-zoom"
                            src="/assets/images/helpers/icon-zoom.svg"
                            alt=""
                        />
                    </div>
                </div>
            </swiper-slide>
            <swiper-slide v-for="(item, index) in gallery" :key="index">
                <div
                    class="wrapper__cover wrapper__cover__img w-full rounded-4 bg-lightgrey-1 bg-center bg-cover bg-no-repeat cursor-pointer"
                    @click="$emit('showmodalgallery')"
                >
                    <img :src="item.image" />
                    <!-- RENDER IMG GALLERY -->
                    <div class="backdrop-zoom">
                        <img
                            class="icon-zoom"
                            src="/assets/images/helpers/icon-zoom.svg"
                            alt=""
                        />
                    </div>
                </div>
            </swiper-slide>
            <!-- Add Pagination -->
            <div class="swiper-pagination" slot="pagination"></div>
            <div
                class="swiper-button-prev"
                slot="button-prev"
            >
                <span class="tx-30 tx-lightgrey-1"
                    ><i class="fas fa-chevron-left fa-lg"></i
                ></span>
            </div>
            <div
                class="swiper-button-next"
                slot="button-next"
            >
                <span class="tx-30 tx-lightgrey-1"
                    ><i class="fas fa-chevron-right fa-lg"></i
                ></span>
            </div>
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
    components: {
        Swiper,
        SwiperSlide
    },
    props: {
        cover: {
            type: String,
            required: true
        },
        gallery: {
            type: Array,
            required: true
        },
        mi_vanguardia_id: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentSlide: 5,
            swiperOptionTop: {
                loop: true,
                loopedSlides: 5,
                spaceBetween: 16,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            swiperOptionThumbs: {
                loop: true,
                loopedSlides: 5,
                spaceBetween: 8,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
                slideToClickedSlide: true,
                breakpoints: {
                    640: {
                        spaceBetween: 12
                    },
                    1024: {
                        spaceBetween: 16
                    }
                }
            }
        };
    },
    methods: {
        isVideo(filename) {
            return /\.mp4$/i.test(filename);
        },
        onSlide: function() {
            this.currentSlide = this.$refs.swiperTop.$swiper.activeIndex;
            this.$emit("updateCurrentSlide", this.currentSlide);
        }
    },
};
</script>
<style scoped>
.swiper-pagination-bullet-active {
    opacity: 1;
    background: #dbfe54 !important;
}
</style>
